import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";
import { INK } from "./theme";

// What a block of the home screen shows while its figures are still being
// fetched. It is given the space that block will occupy once they arrive, so
// the rest of the page does not move when they do.
//
// Props:
//   height — the space to fill, in pixels
const HomePending = ({ height }) => (
  <div
    role="status"
    style={{ height: height, display: "flex", alignItems: "center", justifyContent: "center" }}
  >
    <LoadingSpinner width="32px" height="32px" fillColor={INK.muted} />

    {/* The spinner carries no text of its own, so the state it stands for is
        stated beside it for a screen reader. */}
    <span className="sr-only">{I18n.t("home_dashboard.loading")}</span>
  </div>
);

export default HomePending;
